module.exports = __webpack_public_path__ + "static/media/tz.c31d7c47.svg";